{{ unitPrice | priceValue:pricePrecision:displayCurrency?.value }}{{ unitPrice ? '/' + ( contentUnitId | translateEnum:'UnitShort') : null }}